// src/context/AuthContext.js
import React, { createContext, useState, useContext, useMemo, useCallback } from 'react'; // <-- 1. Tambahkan useCallback

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isLoading, setIsLoading] = useState(false);

  // login dan logout sudah stabil karena tidak bergantung pada state yang berubah
  const login = (userData, authToken) => {
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', authToken);
    setUser(userData);
    setToken(authToken);
  };

  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
    setToken(null);
  };

  // --- PERBAIKAN UTAMA DI SINI ---
  // 2. Bungkus authFetch dengan useCallback
  const authFetch = useCallback(async (url, options = {}) => {
    setIsLoading(true);
    try {
      const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
      };
      // 'token' adalah dependensi, jadi kita harus memasukkannya ke array
      if (token) {
        headers['x-access-token'] = token;
      }
      const response = await fetch(url, { cache: 'no-store', ...options, headers });
      if (response.status === 401) {
        // 'logout' adalah dependensi, tapi karena ia stabil, kita tidak perlu menambahkannya
        logout();
        window.location.href = '/login';
        throw new Error('Sesi Anda telah berakhir. Silakan login kembali.');
      }
      return response;
    } finally {
      setIsLoading(false);
    }
  }, [token]); // <-- 3. Definisikan 'token' sebagai dependensi untuk authFetch

  // Sekarang 'authFetch' sudah stabil, kita bisa dengan aman menambahkannya ke dependensi useMemo
  const value = useMemo(
    () => ({
      user,
      token,
      isLoading,
      login,
      logout,
      authFetch,
    }),
    [user, token, isLoading, authFetch] // <-- 4. Tambahkan 'authFetch' ke dependensi useMemo
  );
  // --- AKHIR PERBAIKAN ---

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};